// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Envelope icon.
 * @param {IconProps} props - The IconProps for the CalendarIcon component.
 * @returns {ReactElement} The CalendarIcon component.
 */

export const Envelope2Icon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='16px' height='16px' viewBox='28 558 161 103' color={color} {...rest}>
      <g fill='none' stroke='currentColor' strokeWidth='14' strokeLinejoin='round' strokeMiterlimit='4'>
        <rect strokeLinecap='round' x='30' y='560.36' width='158' height='100' rx='3' ry='3' />
        <path d='M31.94 561.05L107.71 621.02L186 560.4L31.94 561.05Z' />
      </g>
    </Icon>
  );
};
